import { useMemo } from 'react';
import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';

export function useSelectableUploadItems(
  files: UploadedFile[],
  filterFiles?: (files: UploadedFile[]) => UploadedFile[],
) {
  return useMemo(() => {
    const filtered = filterFiles ? filterFiles(files) : files;

    return filtered
      .filter(file => !file.file.isFolder)
      .map(file => ({
        id: file.id,
        file: file.file,
        title: file.file.fileName,
        description: `Uploaded: ${new Date(file.file.createdAt).toLocaleDateString()}`,
        reviewed: file.isResolved,
      }));
  }, [files, filterFiles]);
}
